 <!-- The Sub Menus that appear on Desktop Top Nav Hovers-->
<template>
  <div>
    <div class="sub-menu">
      <router-link
        v-for="route in routes"
        :key="route.title"
        class="sub-menu__link"
        :to="route.path"
      >{{route.title}}</router-link>
    </div>
  </div>
</template>

<script>
import routes from '@/routes'

export default {
  name: 'SubMenu',
  components: {},
  data() {
    return {
      routes: routes
    }
  }
}
</script>


<style lang="postcss">
.sub-menu {
  @apply shadow-md p-2;
  min-width: 300px;
}
.sub-menu__link {
  @apply py-2 px-4 no-underline text-primary font-semibold text-secondary truncate w-full block;
}
.sub-menu__link:hover {
  @apply bg-primary-lighter;
}
</style>
